import React from "react";
import ImageStepsCard from "./card";

const componentName = "Image Steps Container";

const ImageStepsComponent = (props) => {
  const taggingInfo = {
    componentName: componentName,
    componentVariation: "all",
    componentContent: props["Text-1"] ? props["Text-1"] : "",
    componentProduct: "",
  };

  const cardKeys = Object.keys(props).filter((key) => /^Card-\d+$/.test(key));
  const cardValues = cardKeys.map((key) => props[key]);

  return (
    <>
      <div className="image-spets-card" data-cy="Image Steps Component">
        <div className="content-container">
          {cardValues &&
            Array.isArray(cardValues) &&
            cardValues.length &&
            cardValues.map((item, index) => (
              <div
                key={index}
                className={`padding-card ${item.Layout === "left" ? " bgColor-grey" : ""}`}
              >
                <ImageStepsCard {...item} taggingInfo={taggingInfo} />
              </div>
            ))}
        </div>
      </div>
      <style jsx>{`
        .image-spets-card {
          & :global(*) {
            line-height: 120%;
          }

          .padding-card {
            padding: 1.5rem;
            height: fit-content;
          }

          .bgColor-grey {
            background-color: #f5f5f5;
          }

          .content-container {
            .title-cont {
              margin: 1rem 0;
            }
          }
        }
      `}</style>
    </>
  );
};

export default ImageStepsComponent;
